import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'gender-agender', 'GenderAgender', [["path",{"d":"M6 12a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"}],["path",{"d":"M7 12h11"}]]);